module.exports = __webpack_public_path__ + "img/2.21e6917c.jpg";